'use client';

import { COUNTRIES } from '@/shared/constants/countries';
import { ControlledSelect } from '@/shared/ui/kit/controlled-select';
import { useFormContext, useWatch } from 'react-hook-form';
import { ClearableInput } from '@/shared/ui/kit/clearable-input';
import { CompanyFormData } from '@/shared/lib/validation/registration-wizard/company';


export const CompanyFields = () => {
    const { register, control, formState: { errors }, setValue, clearErrors } = useFormContext<CompanyFormData>();
    const [ companyName, companyVat, postalCode, city, address ] = useWatch({
        control,
        name: [ 'company_name', 'company_vat', 'postal_code', 'city', 'address', 'country' ],
    });

    return (
        <>
            <ClearableInput
                label="Company name"
                placeholder="Enter company name"
                autoComplete="organization"
                error={ errors.company_name?.message }
                required
                value={ companyName }
                onClear={ () => setValue('company_name', '', { shouldValidate: true }) }
                { ...register('company_name') }
                onFocus={ () => clearErrors('company_name') }
            />

            <ClearableInput
                label="Company VAT number"
                placeholder="Enter VAT number"
                error={ errors.company_vat?.message }
                required
                value={ companyVat }
                onClear={ () => setValue('company_vat', '', { shouldValidate: true }) }
                { ...register('company_vat') }
                onFocus={ () => clearErrors('company_vat') }
            />

            <ClearableInput
                label="Postal code"
                placeholder="Enter postal code"
                autoComplete="postal-code"
                error={ errors.postal_code?.message }
                required
                value={ postalCode }
                onClear={ () => setValue('postal_code', '', { shouldValidate: true }) }
                { ...register('postal_code') }
                onFocus={ () => clearErrors('postal_code') }
            />

            <ControlledSelect<CompanyFormData>
                name="country"
                label="Country"
                options={ COUNTRIES }
                placeholder="Select country"
                searchable
                required
            />

            <ClearableInput
                label="City"
                placeholder="Enter city"
                autoComplete="address-level2"
                error={ errors.city?.message }
                required
                value={ city }
                onClear={ () => setValue('city', '', { shouldValidate: true }) }
                { ...register('city') }
                onFocus={ () => clearErrors('city') }
            />

            <ClearableInput
                label="Street address"
                placeholder="Enter street address"
                autoComplete="street-address"
                error={ errors.address?.message }
                required
                value={ address }
                onClear={ () => setValue('address', '', { shouldValidate: true }) }
                { ...register('address') }
                onFocus={ () => clearErrors('address') }
            />
        </>
    );
};
